import { createSlice } from "@reduxjs/toolkit";

const defaultRegistry = {
    id: "-1",
    registryName: "",
    description: "",
    lastUpdate: "1970-01-01T00:00:00",
    lastUpdateByUser: "1970-01-01T00:00:00",
    keys: [],
    isRefreshKeys: false,
    isChangesMade: false
};

export const generalRegSlice = createSlice({
    name: "generalReg",
    initialState: defaultRegistry,
    reducers: {
        setRegistry: (state, action) => {
            return {
                ...action.payload,
                isRefreshKeys: true,
                isChangesMade: false
            };
        },
        resetRegistry: (state) => {
            return {
                ...defaultRegistry,
                isRefreshKeys: true,
                isChangesMade: false
            };
        },
        updateValRegistryName: (state, action) => {
            return {
                ...state,
                registryName: action.payload,
                isChangesMade: true
            };
        },
        updateValDescription: (state, action) => {
            return {
                ...state,
                description: action.payload,
                isChangesMade: true
            };
        },
        addKey: (state) => {
            let regs;

            if (state.keys !== undefined && state.keys !== null) {
                regs = state.keys.map((row) => row);
            } else {
                regs = [];
            }

            const regIndex = regs.findIndex((row) => 
                row.key === "" && row.value === ""  
            );

            if (regIndex >= 0) {
                return {
                    ...state
                };
            }

            regs.push({
                key: "",
                value: ""
            });

            return {
                ...state,
                keys: regs,
                isRefreshKeys: true,
                isChangesMade: true
            };
        },
        updateKey: (state, action) => {
            const {
                key,
                value,
                keyIndex
            } = action.payload;

            let regs;

            if (state.keys !== undefined && state.keys !== null) {
                regs = state.keys.map((row) => row);
            } else {
                regs = [];
            }

            if (regs.length - 1 < keyIndex) {
                return {
                    ...state
                };
            }

            regs.splice(keyIndex, 1, {
                key: key,
                value: value
            });

            return {
                ...state,
                keys: regs,
                isChangesMade: true
            };
        },
        deleteKey: (state, action) => {
            const keyIndex = action.payload;

            let regs;

            if (state.keys !== undefined && state.value !== null) {
                regs = state.keys.map((row) => row);
            } else {
                regs = [];
            }

            if (regs.length - 1 < keyIndex) {
                return {
                    ...state
                };
            }

            regs.splice(keyIndex, 1);

            return {
                ...state,
                keys: regs,
                isRefreshKeys: true,
                isChangesMade: true
            };
        },
        resetRefreshKeys: (state) => {
            return {
                ...state,
                isRefreshKeys: false
            };
        }
    }
});

export const {
    setRegistry,
    resetRegistry,
    addKey,
    updateKey,
    deleteKey,
    updateValRegistryName,
    updateValDescription,
    resetRefreshKeys
} = generalRegSlice.actions;

export default generalRegSlice.reducer;

export const generalRegSelector = (state) => state.generalReg;